import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// 1. IMPORT FILE BARU TADI
import * as serviceWorkerRegistration from './serviceWorkerRegistration'; 
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// 2. UBAH BARIS INI JADI REGISTER
// (Ini perintah supaya browser download & simpan aplikasi di HP)
serviceWorkerRegistration.register(); 

reportWebVitals();